/**
 * Constant for empty object. Is preferred to usage of {}, because it has stable reference.
 * Stable references are important for Redux and React optimizations.
 */
export const EMPTY_OBJECT = {} as const;

/**
 * Constant for empty array. Is preferred to usage of [], because it has stable reference.
 * Stable references are important for Redux and React optimizations.
 */
export const EMPTY_ARRAY = [] as const;
